export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-400"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                夫妻影院
              </span>
            </div>
            <p className="text-xs text-background-400 leading-relaxed">
              夫妻影院提供电视剧全集免费高清在线观看，涵盖国产剧、韩剧、港剧、日剧、美剧等多元化内容。每日更新，秒播不卡顿，致力于成为你最值得信赖的免费追剧平台。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '热门剧集', href: '#cards' },
                { label: '视频专区', href: '#media' },
                { label: '更新动态', href: '#updates' },
                { label: '关于我们', href: '#about' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' }); }}
                    className="text-xs text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-background-50 mb-4">剧集分类</h3>
            <ul className="space-y-2.5">
              {['国产剧', '韩剧', '港剧', '日剧', '美剧'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#index"
                    onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                    className="text-xs text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold text-background-50 mb-4">合作与声明</h3>
            <ul className="space-y-2.5">
              <li>
                <a href="#contact" onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-400 hover:text-primary-400 transition-colors">
                  联系我们
                </a>
              </li>
              <li><span className="text-xs text-background-500">免责声明</span></li>
              <li><span className="text-xs text-background-500">版权声明</span></li>
              <li><span className="text-xs text-background-500">隐私政策</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 夫妻影院 - 电视剧全集免费高清在线观看。本站所有资源均来自互联网，仅供交流学习使用。
            </p>
            <div className="flex items-center gap-4">
              <span className="w-5 h-5 flex items-center justify-center text-background-500 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-5 h-5 flex items-center justify-center text-background-500 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-5 h-5 flex items-center justify-center text-background-500 hover:text-primary-400 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </span>
            </div>
          </div>

          <div className="mt-6 pt-4 border-t border-background-700/30">
            <h4 className="text-xs font-medium text-background-400 mb-3">合作伙伴</h4>
            <p className="text-xs text-background-500">敬请期待更多合作伙伴入驻</p>
          </div>
        </div>
      </div>
    </footer>
  );
}